import type { CreditPackage } from '../credits/lib/paymentMethods'
import { usdText } from '../credits/lib/paymentMethods'

/**
 * Примерная цена кредитов в долларах — для подписи «≈ $3.17» у трат. Всегда
 * доллары, на любом языке интерфейса (решение заказчика): рублёвая цена
 * доступна не всем — без почты в профиле картой не заплатить. Курс — по САМОМУ
 * МАЛЕНЬКОМУ пакету (базовая цена без скидки объёма): какой пакет купил автор,
 * история трат не знает.
 *
 * `Number` допустим: это прикидка с «≈», а не сумма к оплате — денежная
 * математика без округлений живёт в `money.ts`.
 */
export const approxPrice = (
  credits: string,
  packages: CreditPackage[] | undefined,
): string | null => {
  const base = [...(packages ?? [])].sort((a, b) => Number(a.credits) - Number(b.credits))[0]
  const amount = Number(credits)
  const size = Number(base?.credits)
  const price = Number(base?.priceUsd)
  if (!base || !Number.isFinite(amount) || !(size > 0) || !(price > 0)) return null
  return usdText(((amount * price) / size).toFixed(2))
}
